'use client';

import { EVENT_NAMES, trackEvent } from '@/analytics';
import { Button } from '@/components/Button';
import CaretDoubleDown from '@/icons/react/CaretDoubleDown';
import { type JumpLinkType, useJumpLinks } from '@/providers';

interface ScrollToContentButtonProps {
  className?: string;
}

export function ScrollToContentButton({
  className,
}: ScrollToContentButtonProps) {
  const { jumpLinks } = useJumpLinks();

  // TODO: refactor to use JumpLinksProvider handleClick
  function handleClick(jumpLink: JumpLinkType) {
    if (jumpLink.destinationRef?.current) {
      jumpLink.destinationRef.current.scrollIntoView({ behavior: 'smooth' });

      try {
        window.history.pushState(null, '', `#${jumpLink.id}`);
      } catch (err) {
        console.warn('Error pushing state to history', err);
      }
    }

    trackEvent(EVENT_NAMES.jumplink_click, {
      link_id: jumpLink.id,
      link_label: jumpLink.navLabel.full,
      page_name: 'homepage',
    });
  }
  return (
    <Button
      onClick={() => handleClick(jumpLinks[0])}
      variant="solid"
      size="xl"
      color="black"
      className={className}
      title="Scroll down to explore more"
    >
      Discover 1440
      <CaretDoubleDown />
    </Button>
  );
}
